module.exports = __webpack_public_path__ + "img/fitshow-title-back-image-4.ddc97150.jpg";